import { ArrowLeft } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link, Outlet } from 'react-router-dom'

/**
 * Layout brutal para las pantallas de login/register.
 *
 * Sin header global — son flujos focalizados (cero distracciones, cero nav)
 * con un único botón "Volver" arriba a la izquierda (brutal-sm, prominente)
 * que devuelve al usuario a la landing por si pulsó Entrar / Crear cuenta
 * por equivocación.
 *
 * Card interno brutal-lg para que encaje con el lenguaje brutalismo lúdico
 * del resto de la app.
 */
export function AuthLayout() {
  const { t } = useTranslation()

  return (
    <div className="landing-bg flex min-h-dvh flex-col">
      {/* Skip-link a11y — invisible hasta recibir focus */}
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-sm focus:bg-card focus:px-4 focus:py-2 focus:text-foreground focus:ring-2 focus:ring-blue"
      >
        {t('common.skipToContent')}
      </a>
      {/* Botón Volver — header propio en flujo en mobile (evita solapamiento
          con el h1 del card a 360px), posición absolute en md+ donde sobra
          espacio. */}
      <header className="px-4 pt-4 md:px-0 md:pt-0">
        <Link
          to="/"
          className="brutal-sm brutal-press inline-flex items-center gap-2 rounded-lg bg-background px-4 py-2 font-display text-sm font-bold text-foreground transition-colors hover:bg-yellow/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue md:absolute md:left-6 md:top-6 md:z-10 md:px-5 md:py-2.5 md:text-base"
        >
          <ArrowLeft size={18} strokeWidth={2.5} aria-hidden="true" />
          {t('common.back')}
        </Link>
      </header>

      <main
        id="main"
        tabIndex={-1}
        className="relative flex flex-1 items-center justify-center p-4 focus:outline-none"
      >
        <div className="brutal-lg w-full max-w-md rounded-2xl bg-background p-6 sm:p-8">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
